// Simple pub-sub for in-flight API request counter.
let count = 0;
const listeners = new Set();

export const loading = {
  inc() {
    count += 1;
    listeners.forEach((fn) => fn(count));
  },
  dec() {
    count = Math.max(0, count - 1);
    listeners.forEach((fn) => fn(count));
  },
  get() {
    return count;
  },
  subscribe(fn) {
    listeners.add(fn);
    return () => listeners.delete(fn);
  },
};
